const topics = [
  { id: 1, name: '热血少年', icon: 'ri-fire-line', count: '2,340部', hot: true },
  { id: 2, name: '恋爱甜宠', icon: 'ri-heart-line', count: '1,892部', hot: true },
  { id: 3, name: '奇幻冒险', icon: 'ri-compass-3-line', count: '3,156部', hot: true },
  { id: 4, name: '悬疑推理', icon: 'ri-search-eye-line', count: '987部', hot: false },
  { id: 5, name: '转生异世界', icon: 'ri-loop-left-line', count: '1,654部', hot: true },
  { id: 6, name: '青春校园', icon: 'ri-book-read-line', count: '1,203部', hot: false },
  { id: 7, name: '热血格斗', icon: 'ri-boxing-line', count: '876部', hot: false },
  { id: 8, name: '末世生存', icon: 'ri-alert-line', count: '543部', hot: true },
  { id: 9, name: '搞笑日常', icon: 'ri-emotion-laugh-line', count: '2,109部', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-22 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            发现你感兴趣的漫画分类与话题
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <span
              key={topic.id}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium cursor-pointer transition-all whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                  : 'bg-background-100 border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-600'
              }`}
            >
              <i className={`${topic.icon} text-base`}></i>
              <span>{topic.name}</span>
              <span className="text-xs opacity-60 ml-1">({topic.count})</span>
              {topic.hot && (
                <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-accent-100 text-accent-600 leading-none">
                  HOT
                </span>
              )}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}